import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { theme } from '../../styles/theme';

const BannerContainer = styled.div`
  position: fixed;
  top: 240px; /* Position below announcement banner (27px) + navbar (120px) + opening status banner (60px) + some spacing */
  left: 0;
  right: 0;
  background: #0a1530;
  color: white;
  padding: 0.8rem 2rem;
  z-index: 100; /* Lower than navbar but higher than content */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  border-bottom: 2px solid ${props => props.theme.colors.accent};
  display: flex;
  align-items: center;
  justify-content: center;
  animation: slideDown 0.5s ease-out forwards;
  
  @keyframes slideDown {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  &.flash {
    animation: flash 1.5s ease-in-out;
  }

  @keyframes flash {
    0% {
      background: #0a1530;
    }
    25% {
      background: #1a2b4a;
    }
    50% {
      background: #0a1530;
    }
    75% {
      background: #1a2b4a;
    }
    100% {
      background: #0a1530;
    }
  }

  @media (max-width: 1024px) {
    top: 220px;
  }

  @media (max-width: 768px) {
    top: 280px; /* Increased from 220px to 260px for mobile only */
    padding: 0.6rem 1rem;
    margin-top: 0;
  }
`;

const BannerContent = styled.div`
  max-width: 1200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }
`;

const InfoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const Icon = styled.div`
  font-size: 1.2rem;
  color: ${props => props.theme.colors.accent};
`;

const TextContent = styled.div`
  font-size: 1rem;
  line-height: 1.4;
  
  p {
    margin: 0;
  }
`;

const ImportantText = styled.span`
  font-weight: 600;
  color: ${props => props.theme.colors.accent};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
  
  &:hover {
    opacity: 0.8;
  }
`;

const ClosureBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [shouldShow, setShouldShow] = useState(true);
  const [showFlash, setShowFlash] = useState(false);

  useEffect(() => {
    const closureEndDate = new Date('2025-06-23');
    const currentDate = new Date();
    
    // Hide banner if current date is after closure end date
    if (currentDate > closureEndDate) {
      setShouldShow(false);
    }

    // Add flash class after slide-down animation completes
    const timer = setTimeout(() => {
      setShowFlash(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible || !shouldShow) return null;

  return ( 
    <BannerContainer className={showFlash ? 'flash' : ''}>
      <BannerContent>
        <InfoSection>
          <Icon>
            <FontAwesomeIcon icon={faInfoCircle} />
          </Icon>
          <TextContent>
          <p>
  <ImportantText>Important Notice:</ImportantText> Due to a private family event, Belvoir Castle and Gardens will be closed from <ImportantText>16th-23rd June 2025</ImportantText>. The Belvoir Retail Village will also be closed to the general public on <ImportantText>Sunday 22nd June 2025</ImportantText>. We apologise for any disappointment caused.
</p>
          </TextContent>
        </InfoSection>
        <CloseButton onClick={() => setIsVisible(false)}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      </BannerContent>
    </BannerContainer>
  );
};

export default ClosureBanner; 